module.exports = __webpack_public_path__ + "static/img/com4.ec09dcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/product/components/imgs/com4.jpg
// module id = l7y+
// module chunks = 1